import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {toast} from 'react-toastify';
import {Wrapper, ErrorPage} from '../../components/common';
import TreasureChest from '../../components/TreasureChest';
import {fetchTreasures, redeemTreasure, redeemClean} from '../../actions/treasures';
import {setSidebarStatus, setHelpStatus} from '../../actions/user';
import {appId} from '../../store';
import {LIST_PAGE_SIZE} from '../../configs/constants';
import {treasureRedeemedMessage} from '../../configs/messages';

class TreasureChestContainer extends Component {
  static defaultTypes = {
    application: {details: {treasureChest: true}},
  };

  static propTypes = {
    leaders: PropTypes.shape({}).isRequired,
    onFetchTreasures: PropTypes.func.isRequired,
    onRedeemTreasure: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    application: PropTypes.shape({
      details: PropTypes.shape({
        treasureChest: PropTypes.bool,
      }),
    }).isRequired,
    treasures: PropTypes.shape({
      redeemSuccess: PropTypes.bool.isRequired,
    }).isRequired,
  };

  componentDidMount() {
    this.redeemToast();
  }

  componentDidUpdate() {
    this.redeemToast();
  }

  onTreasuresQuery = (params) => {
    const {
      onFetchTreasures,
      treasures: {
        hasMore,
        isTreasureListFetching,
        page: currentPage,
      },
    } = this.props;
    const {resetPage = false, query} = params;
    const page = resetPage ? 1 : currentPage;
    if (!isTreasureListFetching && (resetPage || hasMore)) {
      onFetchTreasures({
        appId,
        page,
        size: LIST_PAGE_SIZE,
        query,
      });
    }
  };

  onTreasureChestRedeem = (treasureId) => {
    const {onRedeemTreasure} = this.props;
    onRedeemTreasure({treasureId});
  };

  redeemToast() {
    const {treasures: {redeemSuccess}, dispatch} = this.props;
    if (redeemSuccess) {
      toast.success(treasureRedeemedMessage);
      dispatch(redeemClean());
    }
  }

  render() {
    const {application: {details = {}}} = this.props;
    const {treasureChest: isTreasureChestAvaible, id: gameId} = details;

    if (!gameId) {
      return null;
    }

    return (
      <Wrapper {...this.props}>
        <div className="cell cell_full">
          {!isTreasureChestAvaible ?
            <ErrorPage/> :
            <TreasureChest
              onTreasuresQuery={this.onTreasuresQuery}
              onTreasureChestRedeem={this.onTreasureChestRedeem}
              {...this.props}
            />
          }
        </div>
      </Wrapper>
    );
  }
}

const mapStateToProps = ({
  application, leaders, treasures, user,
}) => ({
  application, leaders, treasures, user,
});

const bindActions = dispatch => (
  {
    onFetchTreasures: params => dispatch(fetchTreasures(params)),
    onRedeemTreasure: params => dispatch(redeemTreasure(params)),
    sidebarToggle: params => dispatch(setSidebarStatus(params)),
    helpToggle: params => dispatch(setHelpStatus(params)),
    dispatch,
  }
);

export default connect(mapStateToProps, bindActions)(TreasureChestContainer);
